import { render, staticRenderFns } from "./EditarListaPrecio.vue?vue&type=template&id=1b812b68"
import script from "./EditarListaPrecio.vue?vue&type=script&lang=js"
export * from "./EditarListaPrecio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports